import React from "react";
import { ArrowRight2 } from "iconsax-react";

function QuestionSection() {
  const questions = [
    {
      status: "답변 완료",
      course: "JavaScript 기초",
      date: "23.02.04 23:59",
      icon: <ArrowRight2 />,
    },
    {
      status: "미확인",
      course: "JavaScript 기초",
      date: "23.02.04 23:59",
      icon: <ArrowRight2 />,
    },
    {
      status: "답변 완료",
      course: "JavaScript 기초",
      date: "23.02.04 23:59",
      icon: <ArrowRight2 />,
    },
    {
      status: "답변 완료",
      course: "JavaScript 기초",
      date: "23.02.04 23:59",
      icon: <ArrowRight2 />,
    },
    {
      status: "답변 완료",
      course: "JavaScript 기초",
      date: "23.02.04 23:59",
      icon: <ArrowRight2 />,
    },
  ];

  return (
    <div className="bg-white">
      <div className="flex items-center justify-between p-2 mb-4 border-b">
        <h3 className="text-lg font-bold">문의사항</h3>
      </div>
      <ul>
        {questions.map((question, index) => (
          <li key={index} className="flex items-center justify-between py-2">
            <div className="flex items-center gap-4">
              <span
                className={`flex items-center justify-center w-20 h-8 text-xs rounded ${
                  question.status === "답변 완료"
                    ? "bg-blue-100  border-blue-500 text-blue-500 text-blue-500"
                    : "bg-gray-100 border text-gray-500"
                }`}
              >
                {question.status}
              </span>
              <div>
                <p className="text-gray-900">{question.course}</p>
                <p className="text-xs text-gray-500">{question.date}</p>
              </div>
            </div>
            <div className="mr-4 text-2xl text-blue-500">{question.icon}</div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default QuestionSection;
